import { defineComponent as _defineComponent } from 'vue'
import { updateBasePlank } from '@/apis/baseMaterial/blankTable/index'
import GBaseModal from '@/components/g-base-modal.vue'
import { buryPointFunc } from '@/util/buryPointDeal'
import { translate } from '@/util/commonFun'
import { genFinalRecord } from '@/util/commonFuncs'
import {
  baseMaterialSettingFormTextObj,
  baseMaterialSettingFormValueObj,
} from '@/util/operateRecordConfigure/baseMaterialConfigure'
import { regReplaceBaseMaterialDefaultInputCheck } from '@/util/regReplace'
import { message } from 'ant-design-vue'
import { computed, onMounted, ref } from 'vue'

// 指定挂载到当前的容器
interface FormData {
  autoAddSpecialPlate: boolean
  isAutoSelected: boolean
  onlyLayoutTooBig: boolean
  default_oversize_plank_value: {
    width: string | number
    height: string | number
    checked: boolean
  }
}

type OversizeField = 'height' | 'width'

type SelectType = 'autoAddSpecialPlate' | 'isAutoSelected' | 'onlyLayoutTooBig'

// 埋点与type的映射关系

export default /*#__PURE__*/_defineComponent({
  __name: 'm-baseMaterial-setting-modal',
  props: {
    visible: { type: Boolean, default: false },
    title: { default: 'main.head.setting' },
    formData: null
  },
  emits: ["update:visible", "success"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', val: boolean): void
  (e: 'success'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, title: string, formData: Partial<FormData> }

const getContainer = () =>
  document.querySelector('.m-baseMaterial-setting-container')





function translateLang(key: string): string {
  return translate(key)
}

const formData = ref<FormData>({
  autoAddSpecialPlate: false,
  isAutoSelected: false,
  onlyLayoutTooBig: false,
  default_oversize_plank_value: {
    width: 1220,
    height: 2750,
    checked: false,
  },
})

const oriFormData = ref<FormData>({
  autoAddSpecialPlate: false,
  isAutoSelected: false,
  onlyLayoutTooBig: false,
  default_oversize_plank_value: {
    width: 1220,
    height: 2750,
    checked: false,
  },
})

const oversizeInputAlert = ref<Record<OversizeField, string>>({
  height: '',
  width: '',
})

const oversizeInputLabelMap: Record<OversizeField, string> = {
  height: '大板长度',
  width: '大板宽度',
}

function shouldValidateOversizePlankSize() {
  return (
    formData.value.autoAddSpecialPlate &&
    formData.value.default_oversize_plank_value.checked
  )
}

function clearOversizeInputAlert() {
  oversizeInputAlert.value = { height: '', width: '' }
}

function handleDefaultOversizeCheckedChange() {
  if (!formData.value.default_oversize_plank_value.checked) {
    clearOversizeInputAlert()
  }
}

function dealOversizeDecimal(field: OversizeField) {
  const raw = String(formData.value.default_oversize_plank_value[field] ?? '')
  const reg = /[^\d.]/
  let hasInvalidChar = false
  if (raw !== '' && reg.test(raw)) {
    hasInvalidChar = true
  }
  formData.value.default_oversize_plank_value[field] =
    regReplaceBaseMaterialDefaultInputCheck(raw, 'decimal')
  return hasInvalidChar
}

function handleOversizeInputCheck(field: OversizeField) {
  if (!shouldValidateOversizePlankSize()) {
    oversizeInputAlert.value[field] = ''
    return
  }
  if (dealOversizeDecimal(field)) {
    oversizeInputAlert.value[
      field
    ] = `${oversizeInputLabelMap[field]}只能输入数字!`
  } else {
    const value = formData.value.default_oversize_plank_value[field]
    if (value === '' || Number(value) === 0) {
      oversizeInputAlert.value[
        field
      ] = `${oversizeInputLabelMap[field]}不能为空!`
    } else {
      oversizeInputAlert.value[field] = ''
    }
  }
  const normalized = String(formData.value.default_oversize_plank_value[field])
  formData.value.default_oversize_plank_value[field] =
    normalized.indexOf('.') > 0
      ? `${normalized.split('.')[0].substring(0, 5)}.${
          normalized.split('.')[1]
        }`
      : normalized.substring(0, 5)
}

function validateOversizePlankSize() {
  if (!shouldValidateOversizePlankSize()) {
    clearOversizeInputAlert()
    return true
  }
  let valid = true
  ;(['height', 'width'] as OversizeField[]).forEach((field) => {
    handleOversizeInputCheck(field)
    if (oversizeInputAlert.value[field]) {
      valid = false
    }
  })
  return valid
}

function initFormData() {
  const source = props.formData
  formData.value = {
    autoAddSpecialPlate: source.autoAddSpecialPlate ?? false,
    isAutoSelected: source.isAutoSelected ?? false,
    onlyLayoutTooBig: source.onlyLayoutTooBig ?? false,
    default_oversize_plank_value: {
      width: source.default_oversize_plank_value?.width ?? 1220,
      height: source.default_oversize_plank_value?.height ?? 2750,
      checked: source.default_oversize_plank_value?.checked ?? false,
    },
  }
  oriFormData.value = JSON.parse(JSON.stringify(formData.value))
  oversizeInputAlert.value = { height: '', width: '' }
}

function normalizeSettingFormData(data: FormData): FormData {
  return {
    ...data,
    default_oversize_plank_value: {
      ...data.default_oversize_plank_value,
      width: Number(data.default_oversize_plank_value.width),
      height: Number(data.default_oversize_plank_value.height),
    },
  }
}

function saveSettingRecord(current: FormData, ori: FormData) {
  genFinalRecord(
    {
      key: '',
      operateArr: [
        {
          key: '',
          dataArr: [
            {
              type: 'form',
              current: normalizeSettingFormData(current),
              ori: normalizeSettingFormData(ori),
              compareMsg: [
                {
                  title: '特殊大板设置',
                  keys: [
                    'autoAddSpecialPlate',
                    'default_oversize_plank_value',
                    'isAutoSelected',
                    'onlyLayoutTooBig',
                  ],
                },
              ],
              formTextObj: baseMaterialSettingFormTextObj,
              formValueObj: baseMaterialSettingFormValueObj,
            },
          ],
        },
      ],
    },
    'origin_plank_management',
    -2,
    () => {
      console.log('保存成功')
    }
  )
}

const selectTypeMap = new Map<SelectType, string>([
  ['autoAddSpecialPlate', '原片管理-自动添加特殊大板弹窗'],
  ['isAutoSelected', '原片管理-自动选用特殊大板'],
  ['onlyLayoutTooBig', '原片管理-特殊大板只排超尺小板'],
])

// 修改isAutoSelected的处理
const handleChangeIsAutoSelected = (e: any) => {
  const { checked } = e.target
  if (!checked) {
    formData.value.onlyLayoutTooBig = false
  }
}

const visible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emit('update:visible', val)
    return true
  },
})
const confirmLoading = ref(false)
const handleConfirm = async () => {
  if (!validateOversizePlankSize()) {
    return
  }
  confirmLoading.value = true

  try {
    const params = {
      uid: formData.value.autoAddSpecialPlate,
      data: {
        auto_add_special_plate: formData.value.autoAddSpecialPlate,
        isAutoSelected: formData.value.isAutoSelected,
        only_layout_too_big: formData.value.onlyLayoutTooBig,
        default_oversize_plank_value:
          formData.value.default_oversize_plank_value,
      },
    }
    const res = await updateBasePlank(params)
    if (res.data.status !== 1) {
      return message.error(translateLang('materialPage.save.fieldTip'))
    }
    message.success(translateLang('materialPage.save.successTip'))

    saveSettingRecord(formData.value, oriFormData.value)
    visible.value = false
    // 添加埋点
    addBuriedPoint()
    emit('success')
  } catch (error) {
    console.log('保存失败', error)
  } finally {
    confirmLoading.value = false
  }
}

// 添加埋点
const addBuriedPoint = () => {
  const fns: ReturnType<typeof buryPointFunc>[] = []
  selectTypeMap.forEach((_, key) => {
    if (formData.value[key] !== props.formData[key]) {
      fns.push(buryPointFunc(selectTypeMap.get(key) as string))
    }
  })
  if (fns.length) Promise.all(fns)
}

// 关闭弹窗
const handleCancel = () => {
  visible.value = false
}

onMounted(() => {
  initFormData()
})

return { __sfc: true,getContainer, props, emit, translateLang, formData, oriFormData, oversizeInputAlert, oversizeInputLabelMap, shouldValidateOversizePlankSize, clearOversizeInputAlert, handleDefaultOversizeCheckedChange, dealOversizeDecimal, handleOversizeInputCheck, validateOversizePlankSize, initFormData, normalizeSettingFormData, saveSettingRecord, selectTypeMap, handleChangeIsAutoSelected, visible, confirmLoading, handleConfirm, addBuriedPoint, handleCancel, GBaseModal }
}

})